var Promise = require('bluebird');
var m = require('mithril');
var prop = require('mithril/stream');
var moment = require('moment-timezone');

var dragscroll = require('../libs/dragscroll');
var header = require('../layout/components/header');
var heading = require('../components/heading');
var loaders = require('../layout/components/loaders');

var dateFormat = 'MM/DD/YYYY hh:mm:ss a';

var page = {};

page.oninit = function () {
  var ctrl = this;
  document.title = 'nimrod | Audit';
  header.vm.activeTab('Audit');
  ctrl.points = prop([]);
  ctrl.resources = prop([]);
  ctrl.resourceData = prop([]);
  ctrl.offset = prop(0);
  ctrl.filterByTimeOffline = prop(false);
  ctrl.successSortMode = prop(false);
  ctrl.attemptSortMode = prop(false);

  loaders.requestWithLoader({
    url: "/api/v1/errors/",
    method: "GET"
  })
  .then(function (result) {
    ctrl.points(result);
    return loaders.requestWithLoader({
      url: "/api/v1/audit/pointresources",
      method: "POST",
      body: ctrl.points().slice(ctrl.offset(), ctrl.offset() + 1000)
    })
  })
  .then(function (result) {
    ctrl.resourceData(result);
    ctrl.filterResourcesByTimeOffline();
  });

  ctrl.sortResourcesBySuccess = function () {
    ctrl.successSortMode(!ctrl.successSortMode());
    if (ctrl.successSortMode()) {
      ctrl.resources().sort((a,b) => (a.updated || 0) - (b.updated || 0));
    } else {
      ctrl.resources().sort((a,b) => (b.updated || 0) - (a.updated || 0));
    }
  }

  ctrl.sortResourcesByAttempt = function () {
    ctrl.attemptSortMode(!ctrl.attemptSortMode());
    if (ctrl.attemptSortMode()) {
      ctrl.resources().sort((a,b) => a.polled - b.polled);
    } else {
      ctrl.resources().sort((a,b) => b.polled - a.polled);
    }
  }

  ctrl.filterResourcesByTimeOffline = function (missedSamples) {
    var filtered = ctrl.resourceData().filter(function (resource) {
      if (isNaN(resource.interval) || resource.interval == 0) { return false }
      if (!resource.updated) { return true }
      var filterDuration  = resource.interval * 1000 * (missedSamples || 5);
      return resource.updated < (Date.now() - filterDuration);
    });
    ctrl.resources(filtered);
    ctrl.sortResourcesBySuccess();
  }
};

page.view = function () {
  var ctrl = this
  return m('div.container.overflow-hidden', [
    m(heading, {label: 'Offline Resources', class: 'f-subheadline mb3 pb1 display'}, ctrl.resources().length),
    m('div.dragscroll-container', [
      m('div.dragscroll', {oncreate: dragscroll}, [  
        m('table.w-100.f4.mb5', [
          m('thead', [
            m('tr', [ 
              m('th.ph0.tl', { onclick: ctrl.sortResourcesByAttempt }, [
                'Last Attempt',
                ctrl.attemptSortMode() ? m('i.ion-ios-arrow-down.ml2') : m('i.ion-ios-arrow-up.ml2')
              ]),
              m('th.ph0.tl', { onclick: ctrl.sortResourcesBySuccess }, [
                'Last Success',
                ctrl.successSortMode() ? m('i.ion-ios-arrow-down.ml2') : m('i.ion-ios-arrow-up.ml2')
              ]),
              m('th.ph0.tl', 'Name'),
              m('th.ph0.tl', 'Monitored'),
              m('th.ph0.tl', [
                'Offline For'
              ])
            ])
          ]),
          m('tbody', [
            ctrl.resources().map(function (r) {
              return m('tr', [
                m('td.tl', m('div', {style: {width: '12em'}}, moment(r.polled).format(dateFormat))),
                m('td.tl', m('div', {style: {width: '12em'}}, r.updated ? moment(r.updated).format(dateFormat) : null)),
                m('td.tl', 
                  m('a.red', {href: '/#/' + (r['@id'].split('/').slice(3).join('/').toLowerCase())}, 
                    (function () {
                      if (Array.isArray(r.breadcrumbs)) {
                        return r.breadcrumbs.map(function (e) {return e.name}).join(' > ')
                      } else {
                        return r.breadcrumbs
                      }
                    })()
                  )
                ),
                m('td.tl', Boolean(r.children.filter(p => Boolean(Number(p.alarmEnabled))).length) ? '✅' : ''),
                m('td.tl', m('div', {style: {width: '12em'}}, r.updated ? moment.duration(Date.now() - r.updated).humanize() : 'Forever')),
              ])
            })
          ])
        ])
      ])
    ])
  ])
}

module.exports = page;
